
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { LoginPanel } from '@mg/micro/vue2/LoginPanel'
import {
  DesktopIconsItem as HeaderDesktopIconsItem,
  RoundedButton,
} from '@mg/micro/vue2'
import IconUserOutline from '@mg/web-components/Atoms/Icon/IconUserOutline.vue'
import { GQLUser } from '~/graphql/__generated__/interfaces'
import AppLink from '~/components/AppLink.vue'
import ROUTES from '~/config/routes'
import LoginForm from '~/components/LoginForm.vue'
import { createUrl } from '~/utils/routes'
import { GQLLocalOpenHeaderEnum } from '~/graphql/__generated__/interfacesLocal'

@Component({
  components: {
    AppLink,
    RoundedButton,
    HeaderDesktopIconsItem,
    IconUserOutline,
    LoginForm,
    LoginPanel,
  },
  filters: {
    name: ({ lastName, firstName }: GQLUser) => `${firstName} ${lastName}`,
    shortName: ({ lastName, firstName }: GQLUser) =>
      `${firstName} ${lastName?.slice(0, 1) ?? ''}.`,
  },
})
export default class HeaderUserUnsigned extends Vue {
  @Prop({ default: 'right', type: String }) dropDownPosition: 'left' | 'right'
  @Prop(Boolean) isOpenState: boolean = false
  routes = ROUTES
  errorMessage: string | null | undefined = null

  @Emit('changeTab')
  changeTab(tabName: null | GQLLocalOpenHeaderEnum) {
    return tabName
  }

  @Emit()
  closeTab() {}

  get translations() {
    return {
      login: this.$t('common.cta_login') as string,
      forgottenPassword: this.$t(
        'common.cta_password_forgotten_short'
      ) as string,
      stillWithoutAccount: this.$t('common.still_without_account') as string,
      registrationCta: this.$t('common.registration_form_register') as string,
    }
  }

  open() {
    this.changeTab(GQLLocalOpenHeaderEnum.User)
  }

  closed() {
    this.closeTab()
  }

  openToggle() {
    this.isOpenState ? this.closed() : this.open()
  }

  onRegistrationClick() {
    this.$router.push({
      path: createUrl(ROUTES.userRegistration, this.$shopConfig.shopId),
    })
  }
}
